<template>
    <div>
        
        <slot name="button-open" :openDrawer="() => drawerVisible = true" />

        <div class="drawer-content-container" :class="{ 'is-opened': drawerVisible }" placement="right">
            <div class="drawer-content-wraper">
                <div class="drawer-content-backdrop"
                    @click="drawerVisible = false"></div>
                <div class="drawer-content-body">
                    <div class="drawer-content-title d-flex align-items-center px-3 py-2">
                        <div class="flex-fill">
                            <slot name="header">
                                <strong>{{title}}</strong>
                            </slot>
                        </div>
                        <div>
                            <el-button size="mini" type="danger" circle icon="el-icon-close" @click="drawerVisible = false">
                               
                            </el-button>
                        </div>
                    </div>
                    <div>
                        <slot />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MobileDrawer',
    props: {
        title: {
            type: String,
            default() {
                return ""
            }
        }
    },
    data() {
        return {
            drawerVisible: false
        }
    }
}
</script>
